import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Thin, unobtrusive banner shown only for the read-only demo account
 * (user.is_demo). Signals to visitors that the dashboard is a live demo and
 * that changes are disabled.
 */
const DemoBanner = () => {
  const { user } = useAuth();
  if (!user || !(user.is_demo === 1 || user.is_demo === true)) return null;

  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: '6px 12px',
        background: 'linear-gradient(90deg, #2563eb, #0ea5e9)',
        color: '#fff',
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: 0.2,
        boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
      }}
    >
      <span aria-hidden="true">🔵</span>
      <span>Демо режим — приказ со демо податоци. Менувањето е оневозможено.</span>
    </div>
  );
};

export default DemoBanner;
